// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c2def6e","239":"ffa27a65","712":"6b6ef0fd","732":"0d7324c2"}[chunkId] + ".chunk.js";
};